export default __webpack_public_path__ + "static/banner-hero-8a6801b09e11793970d9859be402c90b.webp";